import './styles.less';
const {
  useEffect,
  useRef
} = React;
const {
  Button,
  ReactIcon: Icon
} = svs.ui;
const Dialog = ({
  hasCloseOnConfirm,
  title,
  confirmLabel,
  isOpen,
  onClose,
  onConfirm,
  validationData,
  hasIcon,
  subtitle,
  isDisabled
}) => {
  const ref = useRef(null);
  useEffect(() => {
    if (isOpen) {
      ref.current?.showModal();
      document?.body?.classList?.add('dialog-open');
    } else {
      ref.current?.close();
      document?.body?.classList?.remove('dialog-open');
    }
  }, [isOpen]);
  const handleConfirm = () => {
    onConfirm();
    if (hasCloseOnConfirm) {
      onClose();
    }
  };
  return <div className="dialog-component">
      <dialog className="dialog-modal" data-testid="dialog-modal" onCancel={onClose} onClick={onClose} ref={ref}>
        <div onClick={e => e.stopPropagation()}>
          <div className="dialog-modalcontent" style={{
          maxWidth: validationData && validationData.length > 0 ? '600px' : '420px'
        }}>
            <div style={{
            textAlign: 'center'
          }}>
              {hasIcon && <Icon color="fc-black" icon="exclamation-sign" size="900" />}
              {title && <h1 className="margin-bottom-1 margin-top-1">
                  {title}
                </h1>}
              {subtitle && <h3>
                  {subtitle}
                </h3>}
            </div>
          </div>
          <div className="dialog-modal-actions">
            <Button className="full-width-button" disabled={isDisabled} inverted onClick={handleConfirm} title={confirmLabel}>
              {confirmLabel}
            </Button>
          </div>
        </div>
      </dialog>
    </div>;
};
Dialog.propTypes = {
  confirmLabel: PropTypes.string,
  hasCloseOnConfirm: PropTypes.bool,
  hasIcon: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  subtitle: PropTypes.node,
  title: PropTypes.string,
  validationData: PropTypes.array
};
export default Dialog;